import React from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/system';

// Wrapper sekcji
const SectionWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  paddingTop: '100px',
  paddingBottom: '100px',
}));

// Nagłówek z podkreśleniem blueunderline.svg
const UnderlinedHeading = styled('span')({
  position: 'relative',
  zIndex: 1,
  display: 'inline-block',
  '&::after': {
    content: '""',
    position: 'absolute',
    zIndex: -1,
    right: 0,
    bottom: -15,
    width: '50%',
    height: '40px',
    backgroundImage: 'url(/img/blueunderline.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'bottom center',
  },
});

// Lista logotypów — klient może tu podmienić ścieżki i alt-texty
const logos = [
  { src: '/img/logoph.png', alt: 'Logo klienta 1' },
  { src: '/img/logoph.png', alt: 'Logo klienta 2' },
  { src: '/img/logoph.png', alt: 'Logo klienta 3' },
  { src: '/img/logoph.png', alt: 'Logo klienta 4' },
  { src: '/img/logoph.png', alt: 'Logo klienta 5' },
];

const Section5 = () => {
  const theme = useTheme();

  return (
    <SectionWrapper component="section">
      <Container maxWidth="xl">
        {/* Nagłówek */}
        <Typography
          variant="h2"
          align="center"
          sx={{
            fontSize: { xs: '28px', md: '54px' },
            fontWeight: 'bold',
            color: 'primary.main',
            mb: '8px',
          }}
        >
          <UnderlinedHeading>Z Bimetrii korzystają:</UnderlinedHeading>
        </Typography>

        {/* Logotypy */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', md: 'space-between' },
            alignItems: 'center',
            mt: '8px',
            flexWrap: 'nowrap',
            overflowX: { xs: 'auto', md: 'visible' },
            overflowY: 'hidden',
            // ukrycie paska scrolla
            '-ms-overflow-style': 'none',      // IE/Edge
            scrollbarWidth: 'none',           // Firefox
            '&::-webkit-scrollbar': { display: 'none' }, // Chrome, Safari, Opera
          }}
        >
          {logos.map(({ src, alt }, idx) => (
            <Box
              key={idx}
              component="img"
              src={src}
              alt={alt}
              sx={{
                flex: '0 0 auto',
                width: { xs: '40%', md: 'auto' },
                height: { xs: '180px', md: '230px' },
                // niewielki odstęp między logo na mobile
                mr: { xs: idx < logos.length - 1 ? 2 : 0, md: 0 },
              }}
            />
          ))}
        </Box>
      </Container>
    </SectionWrapper>
  );
};

export default Section5;
